<!--Navigation Bar-->
<app-navbar>
    <h2>{{"REQRUITING.TITLE" | translate}}</h2>
</app-navbar>

<div class="homepage-about-agri ptb-100">
    <div class="container-fluid overflow-hidden">
        <div class="about-container justify-content-center">
            <div class="img-container col-lg-5 pt-100">
                <img src="/assets/img/recruiter-img.jpg"/>
            </div>
            <div class="text-container col-lg-6 col-md-6">
                <h2 class="pb-8">{{"REQRUITING.ABOUT" | translate}}</h2>
                <div [innerHTML]="'REQRUITING.REQ_HTML' | translate"></div>
                <ol [innerHTML]="'REQRUITING.REQ_LIST' | translate"></ol>
                <p [innerHTML]="'REQRUITING.REQ_HTML2' | translate"></p>
            </div>
        </div>
    </div>
</div>


<!--Footer-->
<app-footer></app-footer>